import React, { useEffect, useState } from 'react';
import { Layout, Menu, Button,Badge } from 'antd';
// import dashboradLogo from '../../assets/dashboradLogo.png'
import dashboradLogo from '../../assets/logo.png';
import { MdOutlineSubscriptions , MdOutlineDashboardCustomize} from "react-icons/md";
import { LiaSitemapSolid } from "react-icons/lia";
import { LiaBusinessTimeSolid } from "react-icons/lia";
import Avatar from '@mui/material/Avatar';
import NotificationModel from '../Layout/NotificationModel'
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  BarChartOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  SettingOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { FaWallet,FaBell} from "react-icons/fa";
import { CiPower } from "react-icons/ci";
import { CgProfile } from "react-icons/cg";
import { Link, Outlet, useLocation } from 'react-router-dom';
import GetLeadsModal from '../Modals/GetLeadsModal';
import { useNavigate } from 'react-router-dom'; // Import the useHistory hook
import { connect } from 'react-redux';
import { setUser } from '../../store/action/common/authAction';
import ManualLeadsModal from '../Modals/ManualLeadsModal';
import { getWalletAmount } from '../../store/action/business/TxnAction';



const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu; 

const SiderDemo = (props) => {

  const companyName = localStorage.getItem('companyName')
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [leadsModalVisible, setLeadsModalVisible] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);


  useEffect(() => {
    props.getWalletAmount_();
  }, []);

  useEffect(() => {
    if (props.user.role === 'business' && props.wallet && props.wallet.response && props.wallet.response.walletAmount) {
      setWalletAmount(props.wallet.response.walletAmount);
      localStorage.setItem('myWallet', JSON.stringify(props.wallet.response.walletAmount));
    }
  }, [props.wallet]);
  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const openModal = () => {
    setModalVisible(true); // Set the modal visibility to true when the button is clicked
  };
  const closeModal = () => {
    setModalVisible(false); // Set the modal visibility to true when the button is clicked
  };

  const openLeadsModal = () => {
    setLeadsModalVisible(true); // Set the modal visibility to true when the button is clicked
  };
  const closeLeadsModal = () => {
    setLeadsModalVisible(false); // Set the modal visibility to true when the button is clicked
  };

  const logout = () => {
    // localStorage.clear();
    // props.setUser_(null);
    // props.clearLoginResponse_();
    // window.location.href = '/login';
    localStorage.clear(); // Clear localStorage
    props.setUser_(null); // Clear user from Redux
    props.clearLoginResponse_(); // Clear login response from Redux
    navigate('/login'); // Use React Router to navigate to login page
  };

  const getButtons = () => {
    if (props.user && props.user.role === 'admin') {
      return (
        <>
             <img style={{
                  width: 'auto',         
                  height: '25px',       
                  marginRight: '15px',  
                  borderRadius: '5px',  
                  border: '2px solid #ccc', 
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)', 
             }}  src='https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Flag_of_Canada.svg/2560px-Flag_of_Canada.svg.png' />
           <Button type="light" style={{ color: 'black', backgroundColor: 'white', borderColor: '#1890ff' }} 
           onClick={openLeadsModal}>Add Leads</Button>
        </>
      )
    }
    
    else if (props.user && props.user.role === 'business') {
      return (
        <div style={{display: "flex",alignItems: "center",justifyContent: "space-between",padding: "10px 20px",}}>
      {/* <Button type="primary" style={{ height: "40px", color: "white",marginRight: "16px", background: "linear-gradient(to right, #5767f3, #172851)",borderColor: "transparent",borderRadius: "6px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",fontWeight: "bold", }}
        onClick={openModal}>
        Upgrade Credits
      </Button> */}
{/* My wallet */}
      <Button type="light" style={{display: "flex",alignItems: "center",fontSize:'15px', marginRight:'10px', backgroundColor:'#F7F7F7', color:'#5F5F5F',
          gap: "10px",height: '40px', padding: "10px 20px", border: "1px solid #ddd",borderRadius: "6px", }} 
          onClick={() => { navigate('/transaction-history'); }}>
            <FaWallet style={{ marginRight: '1px' }} />
            <span>My Credits : {walletAmount}</span> 
          </Button>
{/* Bell Icon */}
     <NotificationModel/>
          {/* <Button type="light" style={{borderRadius: '50%',width: '40px',height: '40px',padding: '0',display: 'flex',
         alignItems: 'center',justifyContent: 'center',backgroundColor: '#f5f5f5', marginRight:'10px',border: 'none',position: 'relative',}}>
           <FaBell style={{ fontSize: '20px', color: '#5F5F5F' }} />
          <div style={{ position: 'absolute', bottom: '10px', right: '5px',width: '8px',height: '8px',borderRadius: '50%',
                  backgroundColor: '#ff4d4f' }}/>
            </Button> */}
{/* Business Profile */}
          <Button type="default"  onClick={() => { navigate('/my-profile'); }}  style={{display: "flex",alignItems: "center",justifyContent: "space-between",gap: "10px",
              padding: "8px 16px", // Adjust padding for consistency
              height: "50px", // Ensure height matches other buttons
              border: "1px solid #ddd",
              borderRadius: "6px",
              cursor: "pointer",
              marginLeft: "auto", 
            }}>
          {/* <img src="https://www.gartner.com/pi/vendorimages/surveysparrow_1722245657042.png"alt="Profile Icon"style={{borderRadius: "50%",width: "30px",height: "30px"}}/> */}
          <Avatar style={{borderRadius: "50%",width: "30px",height: "30px"}} >{companyName?.charAt(0).toUpperCase()}</Avatar>
          {/* Text Section */}
          <div style={{ display: "flex",flexDirection: "column", textAlign: "left" }}>
            <span style={{fontSize: "14px" }}>{companyName || 'My Company'}</span>
            <span style={{ fontSize: "11px", color: "#888" }}>Business Panel</span>
          </div>

  {/* Dropdown Icon */}
  <MdOutlineKeyboardArrowDown size={15} />
</Button>

        </div>
      )
    }
  }

  return (
    <Layout style={{ minHeight: '100vh', width: '100vw' }}>
      <Header className="site-layout-background" 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#ffff',
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={dashboradLogo} style={{ width: '70px', margin:'20px' }} className="logo" />
        {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
          className: 'trigger',
          onClick: toggle,
          style: { fontSize: '20px', color: '#4D5156', marginLeft: '70px' }, 
        })}
      </div>
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px', color: 'white' }}>
          {getButtons()}   
            </div>
      </Header>
      <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}
          style={{
            position: 'fixed',
            top: '64px', // Height of the fixed header
            left: 0,
            bottom: 0,
            zIndex: 1000,
            backgroundColor: '#ffff',
            paddingTop: '20px', }} >
          <div style={{display: 'flex',flexDirection: 'column', height: '100%',}}>
            <div style={{ flex: 1, overflowY: 'auto' }}>
              <Menu
                style={{ marginTop: '10px' }}
                theme="light"
                mode="inline"
                defaultSelectedKeys={[location.pathname]}
                key={location.pathname}
                items={[
                  {
                    key: 'general',
                    type: 'group', // Group header
                    label: <p style={{ fontWeight: 'bold', marginBottom: '0px' }}>Menu</p>,
                  },
                  {
                    key: props.user.role === "admin" ? '/admin' : '/',
                    icon: <BarChartOutlined />,
                    label: (
                      <Link to={props.user.role === 'admin' ? "/admin" : "/"} style={{ textDecoration: 'none' }} >
                        Dashboard
                      </Link>
                    ),
                  },
                  props.user.role === "business" &&  {
                    key: '/my-bussiness-leads',
                    icon: <UsergroupAddOutlined />,
                    label: (
                      <Link to="/my-bussiness-leads" style={{ textDecoration: 'none' }}>
                        My Leads
                      </Link>
                    ),
                  },

                  props.user && props.user.role === 'admin' && {
                    key: '/my-leads',
                    icon: <UsergroupAddOutlined />,
                    label: (
                      <Link to="/my-leads" style={{ textDecoration: 'none' }}>
                        Super Leads
                      </Link>
                    ),
                  },

                  {
                    key: '/transaction-history',
                    icon: <DollarOutlined />,
                    label: (
                      <Link to="/transaction-history" style={{ textDecoration: 'none' }}>
                        Transaction History
                      </Link>
                    ),
                  },
                  props.user.role === "business" && {
                    key: 'general',
                    type: 'group', // Group header for another section
                    label: <p style={{ fontWeight: 'bold', marginBottom: '0px' }}>General</p>,
                  },
                  props.user.role === "business" && {
                    key: '/setting',
                    icon: <SettingOutlined />,
                    label: (
                      <Link to="/setting" style={{ textDecoration: 'none' }}>
                        Settings
                      </Link>
                    ),
                  },
                  props.user.role === "business" && {
                    key: '/helpdesk',
                    icon: <QuestionCircleOutlined />,
                    label: (
                      <Link to="/helpdesk" style={{ textDecoration: 'none' }}>
                        Help Desk
                      </Link>
                    ),
                  },
                  props.user.role === "business" && {
                    key: '/my-profile',
                    icon: <CgProfile size={15} />,
                    label: (
                      <Link to="/my-profile" style={{ textDecoration: 'none' }}>
                        My Profile
                      </Link>
                    ),
                  },
                  
      
                  props.user && props.user.role === 'admin' && {
                    key: '/businesses',
                    icon: <LiaBusinessTimeSolid />,
                    label: (
                      <Link to="/admin/businesses" style={{ textDecoration: 'none' }}>
                        Businesses
                      </Link>
                    ),
                  },
                  props.user && props.user.role === 'admin' && {
                    key: '/business-and-lead-mapping',
                    icon: <LiaBusinessTimeSolid />,
                    label: (
                      <Link to="/admin/business-and-lead-mapping" style={{ textDecoration: 'none' }}>
                        B & L Map
                      </Link>
                    ),
                  },
                  props.user && props.user.role === 'admin' && {
                    key: '/utm-mapping',
                    icon: <LiaSitemapSolid />,
                    label: (
                      <Link to="/admin/utm-mapping" style={{ textDecoration: 'none' }}>
                       UTM Mapping
                      </Link>
                    ),
                  },
                  
              
                  
                  props.user && props.user.role === 'admin' && {
                    key: '/business-mapping',
                    icon: <MdOutlineDashboardCustomize />,
                    label: (
                      <Link to="/admin/business-mapping" style={{ textDecoration: 'none' }}>
                       Customized Plan
                      </Link>
                    ),
                  },
                  props.user && props.user.role === 'admin' && {
                    key: '/subscription-master',
                    icon: <MdOutlineSubscriptions />,
                    label: (
                      <Link to="/admin/subscription-master" style={{ textDecoration: 'none' }}>
                       Subscription master
                      </Link>
                    ),
                  },
                  // props.user && props.user.role === 'admin' && {
                  //   key: '/tickets',
                  //   icon: <ProfileOutlined />,
                  //   label: (
                  //     <Link to="/admin/tickets" style={{ textDecoration: 'none' }}>
                  //       Tickets
                  //     </Link>
                  //   ),
                  // },
                ].filter(Boolean)}/>
              </div>
              <button
                style={{
                  margin: collapsed ? '0 10px 20px 10px' : '0 20px 20px 20px',
                  padding: '10px',
                  backgroundColor: '#FFF2F3',
                  color: '#E72A3D',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
                onClick={logout}>
                <CiPower style={{ fontSize: 'large', margin: '0px 5px 2px 0px'}}/> Logout
              </button>
            </div>
          </Sider>


        <Content
          className="site-layout-background"
          style={{
            marginLeft: collapsed ? '80px' : '200px', // Adjust based on Sider's width
            marginTop: '64px', // Height of the fixed header
            padding: '24px',
            overflowY: 'auto',
            height: 'calc(100vh - 64px)', // Full height minus header height
          }}>
          <Outlet />
        </Content>
      </Layout>
      <GetLeadsModal visible={modalVisible} closeModal={closeModal} />
      <ManualLeadsModal visible={leadsModalVisible} closeModal={closeLeadsModal} />
    </Layout>
  );
};

const mapStateToProps = state => ({
  user: state.user.response,
  wallet: state.wallet
})

const mapDispatchToProps = dispatch => ({
  getWalletAmount_: () => dispatch(getWalletAmount()),
  setUser_: (data) => {
    dispatch(setUser(data));
  },
  clearLoginResponse_: () => {
      dispatch({ type: 'FETCH_LOGIN_CLEAR' });
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiderDemo);


